import { View } from "react-native-ui-lib";
import { SpacingLiterals } from "react-native-ui-lib/src/style/spacings";

export const Spacer = () => {
  return <View style={{ marginBottom: SpacingLiterals.s7 * 3 }} />;
};
